module.exports = __webpack_public_path__ + "static/media/farmacias-del-ahorro.41d8c2fc.svg";